let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bZXwp")).then(() => parcelRequire('6UrsO'));